/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ─── APPAREL PDP — Mobile image gallery arrow fix ─────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 749) return;

    document.querySelectorAll('product-images').forEach(function (el) {

      el.setAttribute('data-fader-mobile', '');

      if (!el.initialized) {
        if (typeof el.initArrows === 'function') el.initArrows();
        if (typeof el.bindEventListeners === 'function') el.bindEventListeners();
      }

      function relocateArrows() {
        var arrows = el.querySelector('.slider__arrows');
        if (arrows && arrows.parentElement !== el) {
          el.appendChild(arrows);
        }
      }
      relocateArrows();

      // Track index explicitly — don't rely on scrollLeft timing
      var currentIndex = 0;

      var proto = Object.getPrototypeOf(el);

var scrolling = false;

      proto.showNextImage = function () {
        if (scrolling) return;
        var zoom = this.querySelector('.product__slides');
        var slides = zoom.querySelectorAll('.product__slide');
        var totalSlides = slides.length;
        var slideWidth = slides[0].offsetWidth;
        currentIndex = (currentIndex + 1) % totalSlides;
        scrolling = true;
        zoom.scrollTo({ left: currentIndex * slideWidth, behavior: 'smooth' });
        setTimeout(function () { scrolling = false; }, 400);
        relocateArrows();
      };

      proto.showPreviousImage = function () {
        if (scrolling) return;
        var zoom = this.querySelector('.product__slides');
        var slides = zoom.querySelectorAll('.product__slide');
        var totalSlides = slides.length;
        var slideWidth = slides[0].offsetWidth;
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        scrolling = true;
        zoom.scrollTo({ left: currentIndex * slideWidth, behavior: 'smooth' });
        setTimeout(function () { scrolling = false; }, 400);
        relocateArrows();
      };
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();